"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildingGovIcon24Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.BuildingGovIcon24Regular = forwardRef_1.forwardRef('BuildingGovIcon24Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M9.986 4.295a3.25 3.25 0 0 1 4.028 0l7.021 5.544a.75.75 0 1 0 .93-1.178l-7.022-5.543a4.75 4.75 0 0 0-5.886 0L2.035 8.661a.75.75 0 1 0 .93 1.178l7.021-5.544Z" }),
        react_1.default.createElement("path", { d: "M6.75 10.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0v-7.5Z" }),
        react_1.default.createElement("path", { d: "M2.75 20.25a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75Z" }),
        react_1.default.createElement("path", { d: "M10 10a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0v-7.5A.75.75 0 0 1 10 10Z" }),
        react_1.default.createElement("path", { d: "M14.75 10.75a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0v-7.5Z" }),
        react_1.default.createElement("path", { d: "M18 10a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0v-7.5A.75.75 0 0 1 18 10Z" })));
});
